// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ReportReportCategory } from './report-report-category';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ReportCategory extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  reportCategoryId!: number;
  comments?: string;
  createdBy!: string;
  createdDate!: Date;
  defaultSelector?: number;
  description!: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  reportReportCategories!: ReportReportCategory[];
}

